import { createSelector } from 'reselect';
import { servicesSelectors } from './services.selectors';

const selectEnvConfig = (state) => state.envConfig;

const selectCurrentPathname = (state) => selectEnvConfig(state)?.history?.location?.pathname;

const selectServicesEnvConfig = createSelector(selectEnvConfig, ({ services } = {}) => services);

const selectFeatures = (state) => selectEnvConfig(state)?.features;

const selectIsNewCalendarEnabled = createSelector(
  selectEnvConfig,
  servicesSelectors.selectServiceName,
  (envConfig, serviceName) => envConfig?.services?.[serviceName]?.newCalendarEnabled,
);

export const envConfigSelectors = {
  selectEnvConfig,
  selectServicesEnvConfig,
  selectCurrentPathname,
  selectFeatures,
  selectIsNewCalendarEnabled,
};
